import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../../components/global/layout';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import { useSelector } from 'react-redux';
import methodModel from '../../../methods/methods';
import rolesModel from '../../../models/roles.model';
import moment from 'moment';
import { MdDownloadForOffline } from 'react-icons/md';

import { IoDocumentAttach } from 'react-icons/io5';
import environment from '../../../environment';

const QuestionViewPage = (p) => {
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const { id, userId } = useParams();
  const [data, setData] = useState({ document: [] });
  const [Permissions, setPermission] = useState({});
  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`question`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);
  const downloadFile = async (pdfUrl) => {
    console.log(pdfUrl, '===========PDF');
    try {
      const response = await fetch(`${environment.api}documents/${pdfUrl}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'documents.pdf');
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">
              View Question
            </h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about your Question
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 border p-5 rounded-md bg-[#a7a7a745] mb-4">
          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Question</label>
            <div className="profiledetailscls bg-[#fff] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.question)}
            </div>
          </div>

          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Answer</label>
            <div className="profiledetailscls bg-[#fff] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data &&
                data?.options?.map((itm) => {
                  return (
                    <>
                      {itm?.isChecked ? (
                        <>
                          {methodModel.capitalizeFirstLetter(itm?.name) || '--'}
                        </>
                      ) : null}
                    </>
                  );
                })}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Options</label>
            <div className='grid grid-cols-12 gap-4'>
            {data &&
              data?.options?.map((itm) => {
                return (
                  <div className="col-span-6 md:col-span-6 profiledetailscls bg-[#fff] px-[10px] py-[8px] min-h-[38px] rounded-md">
                    {methodModel.capitalizeFirstLetter(itm?.name)}
                  </div>
                );
              })}
              </div>
          </div>
          {/* <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Course</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && data?.course_id?.title}
            </div>
          </div> */}
          {data?.document?.length > 0 ? (
            <div className="col-span-12 md:col-span-6">
              <label className="profileheddingcls">Dcoument</label>
              <a>
                <IoDocumentAttach
                  onClick={() => {
                    downloadFile(data?.document[0]);
                  }}
                  size={100}
                />
              </a>
            </div>
          ) : null}

          {/* <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Description</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
            
              <div
                dangerouslySetInnerHTML={{ __html: data?.description }}
              ></div>
            </div>
          </div> */}

          {data?.image ? (
            <div className="col-span-12 md:col-span-12">
              <label className="profileheddingcls">Image</label>
              <div className="flex gap-3 flex-wrap">
                {data?.image?.map((itm) => {
                  return (
                    <div className="imagethumbWrapper">
                      <img
                        src={methodModel.noImg(itm, 'users')}
                        className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default QuestionViewPage;
